import { render, staticRenderFns } from "./PostChart.vue?vue&type=template&id=4535da20&"
import script from "./PostChart.vue?vue&type=script&lang=js&"
export * from "./PostChart.vue?vue&type=script&lang=js&"
import style0 from "./PostChart.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostChart.vue"
export default component.exports